import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrowLeftNavigation.svg'
import _imports_1 from '@/assets/pdfs.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/plus.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-571715ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maincontainer py-8 px-4" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex cursor-pointer" }
const _hoisted_4 = { class: "card mt-4" }
const _hoisted_5 = { class: "p-3 flex flex-row gap-1" }
const _hoisted_6 = { class: "w-3/4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Description")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid mt-2 border-lightgrey" }, null, -1))
const _hoisted_9 = { class: "mt-4 max-h-42 overflow" }
const _hoisted_10 = { class: "mt-5" }
const _hoisted_11 = { class: "header flex items-center justify-between" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "ml-2" }, "Attachments")
], -1))
const _hoisted_13 = { class: "buttonposition flex justify-center items-center mx-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1))
const _hoisted_15 = { class: "flex mt-2 gap-4 flex-wrap" }
const _hoisted_16 = { class: "pdf w-full" }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_19 = { class: "text-xs ml-1" }
const _hoisted_20 = { class: "mt-5" }
const _hoisted_21 = { class: "header flex items-center justify-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ml-2" }, "Links", -1))
const _hoisted_23 = { class: "buttonposition flex justify-center items-center mx-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1))
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "mt-5" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Activity", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_29 = { class: "flex flex-1 flex-wrap tabs-boxed cursor-pointer mt-2" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = {
  key: 0,
  class: "error-text"
}
const _hoisted_34 = { class: "flex justify-end" }
const _hoisted_35 = { class: "singlecomment p-2" }
const _hoisted_36 = { class: "w-1/4 taskdetails px-4" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<h1 class=\"font py-0.5\" data-v-571715ca>Ticket Details</h1><div class=\"border-b border-solid border-lightgrey mt-1 rounded\" data-v-571715ca></div><div class=\"mt-2\" data-v-571715ca><label class=\"controllabel text-xs font-semibold mb-1\" data-v-571715ca>Status:</label><select class=\"inputboxstyling\" data-v-571715ca><option data-v-571715ca>Open</option><option data-v-571715ca>Close</option></select></div><div class=\"mt-2\" data-v-571715ca><label class=\"controllabel text-xs font-semibold mb-1\" data-v-571715ca>Ticket Type:</label><p class=\"mt-1 text-xs font-normal\" data-v-571715ca>Task</p></div><div class=\"mt-2\" data-v-571715ca><label class=\"controllabel text-xs font-semibold mb-1\" data-v-571715ca>Department:</label><p class=\"mt-1 text-xs font-normal\" data-v-571715ca>IT</p></div><div class=\"mt-2\" data-v-571715ca><label class=\"controllabel text-xs font-semibold mb-1\" data-v-571715ca>Assigned To:</label><p class=\"mt-1 text-xs font-normal\" data-v-571715ca>Nikhil</p></div><div class=\"mt-2\" data-v-571715ca><label class=\"controllabel text-xs font-semibold mb-1\" data-v-571715ca>Priority</label><p class=\"mt-1 text-xs font-normal\" data-v-571715ca>Critical</p></div>", 7)
const _hoisted_44 = { class: "mt-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs font-semibold mb-1" }, "Created At", -1))
const _hoisted_46 = { class: "mt-1 text-xs font-normal" }
const _hoisted_47 = { class: "userPopup" }
const _hoisted_48 = {
  key: 0,
  class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-center items-center flex"
}
const _hoisted_49 = { class: "relative my-6 w-full max-w-xl" }
const _hoisted_50 = { class: "border-0 rounded relative flex flex-col w-full bg-white" }
const _hoisted_51 = { class: "flex items-start justify-between p-5 rounded" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Add Links", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "p-2" }
const _hoisted_56 = { class: "text-black no-underline mt-0.5 min-h-30 cursor-pointer" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t-2" }, null, -1))
const _hoisted_58 = { class: "p-4 flex flex-col mt-2" }
const _hoisted_59 = { class: "w-4 mt-2" }
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = { class: "flex justify-center" }
const _hoisted_62 = {
  key: 1,
  class: "opacity-40 fixed inset-0 z-50 bg-black"
}
const _hoisted_63 = {
  key: 0,
  class: "importpopup"
}
const _hoisted_64 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-center items-center flex" }
const _hoisted_65 = { class: "relative my-6 max-w-xl" }
const _hoisted_66 = { class: "border-0 rounded relative flex flex-col w-full bg-white" }
const _hoisted_67 = { class: "flex items-start justify-between p-5" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Import files", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1))
const _hoisted_72 = { class: "relative p-6 flex-auto" }
const _hoisted_73 = { class: "formcontainer flex flex-col" }
const _hoisted_74 = { class: "row flex flex-row w-full" }
const _hoisted_75 = { class: "col-md-6 w-6/12 p-2" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  htmlFor: "upload",
  class: "controllabel"
}, "Select File", -1))
const _hoisted_77 = {
  type: "file",
  id: "upload",
  ref: "element"
}
const _hoisted_78 = { class: "p-2 flex justify-end" }
const _hoisted_79 = {
  key: 0,
  class: "opacity-40 fixed inset-0 z-40 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "w-4 h-4 mr-4 mt-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backtoTasks()))
          })
        ]),
        _createElementVNode("h1", null, _toDisplayString(_ctx.task.taskName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.task.description), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "btnprimary m-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addDocuments()))
                  }, "Attach")
                ])
              ])
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.documents, (n) => {
                return (_openBlock(), _createElementBlock("div", { key: n }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      href: n.documentUrl,
                      class: "flex w-full flex-row items-center flex-wrap"
                    }, [
                      _hoisted_18,
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.fileName(n.documentUrl)), 1)
                    ], 8, _hoisted_17)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "btnprimary m-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTaskModal =true))
                  }, "Links")
                ])
              ])
            ]),
            _hoisted_24,
            _createElementVNode("table", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                return (_openBlock(), _createElementBlock("tr", { key: link }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: link.linkUrl,
                      class: "cursor-pointer"
                    }, _toDisplayString(link.linkUrl), 9, _hoisted_25)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navBarheading, (singlenav, navIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex-auto text-center a",
                  key: singlenav.key
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["tab text-sm font-bold", { correct: _ctx.openTab == navIndex }]),
                    onClick: ($event: any) => (_ctx.toggleTabs(navIndex))
                  }, _toDisplayString(singlenav), 11, _hoisted_30)
                ]))
              }), 128))
            ]),
            (_ctx.openTab == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "",
                    class: "inputboxstyling",
                    placeholder: "Add a Comment",
                    cols: "3",
                    rows: "3",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.comments) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.comments]
                  ]),
                  (_ctx.v$.comments.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_ctx.v$.comments.required.$invalid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Required"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", {
                      class: "btnprimary mt-2 mr-2",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateComments()))
                    }, "Add"),
                    _createElementVNode("button", {
                      class: "btnprimary mt-2",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearComments()))
                    }, "Clear")
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.comments, (comment) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "comments mt-4",
                      key: comment
                    }, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(comment.comments), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.task.createdAt), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          (_ctx.showTaskModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("button", {
                        class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showTaskModal=false))
                      }, _hoisted_54)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", null, [
                          _hoisted_57,
                          _createElementVNode("div", _hoisted_58, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: link,
                                class: "w-100 flex ml-2"
                              }, [
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("img", {
                                    src: _imports_3,
                                    class: "h-5 w-5 cursor-pointer mt-2",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addLink()))
                                  })
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "inputboxstyling mt-2 w-96 ml-2",
                                  "onUpdate:modelValue": ($event: any) => ((link.linkUrl) = $event)
                                }, null, 8, _hoisted_60), [
                                  [_vModelText, link.linkUrl]
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            (!_ctx.updateButton)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btnprimary mb-4",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveLinks()))
                                }, "Save"))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTaskModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62))
            : _createCommentVNode("", true)
        ]),
        (_ctx.newImportModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("button", {
                        class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.newImportModal =!_ctx.newImportModal))
                      }, _hoisted_70)
                    ]),
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _hoisted_76,
                            _createElementVNode("input", _hoisted_77, null, 512)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("button", {
                        class: "btnprimary",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveDocuments()))
                      }, "Save")
                    ])
                  ])
                ])
              ]),
              (_ctx.newImportModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}